(function () {
  if (window.__tdPdpAddonMultiLoaded) return;
  window.__tdPdpAddonMultiLoaded = true;

  var ADDON_SELECTOR = '[data-td-pdp-addon]';
  var CHECKBOX_SELECTOR = '[data-td-pdp-addon-checkbox]';
  var TOGGLE_SELECTOR = '[data-td-pdp-addon-toggle]';
  var QUICKVIEW_SELECTOR = '[data-td-pdp-addon-quickview]';
  var QUICKVIEW_OPEN_SELECTOR = '[data-td-pdp-addon-quickview-open]';
  var QUICKVIEW_CLOSE_SELECTOR = '[data-td-pdp-addon-quickview-close]';
  var QUICKVIEW_SELECT_SELECTOR = '[data-td-pdp-addon-quickview-select]';
  var QUICKVIEW_THUMB_SELECTOR = '[data-td-pdp-addon-quickview-thumb]';

  var activeQuickView = null;
  var activeQuickViewOpener = null;

  function getRoutes() {
    return window.routes || {
      cart_add_url: '/cart/add.js',
      cart_url: '/cart'
    };
  }

  function getForm(addon) {
    var formId = addon.getAttribute('data-form-id');
    var formById = formId ? document.getElementById(formId) : null;

    return (
      formById ||
      addon.closest('form') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function getSubmitButton(form) {
    if (!form) return null;

    return (
      form.querySelector('button[name="add"]') ||
      form.querySelector('[type="submit"][name="add"]') ||
      form.querySelector('[type="submit"]')
    );
  }

  function getButtonLabel(button) {
    if (!button) return null;
    return button.querySelector('span:not(.sold-out-message)') || button;
  }

  function getAddonsForForm(form) {
    if (!form) return [];
    return Array.prototype.slice.call(form.querySelectorAll(ADDON_SELECTOR));
  }

  function getSelectedAddons(form) {
    if (!form) return [];

    return Array.prototype.slice
      .call(form.querySelectorAll(CHECKBOX_SELECTOR + ':checked'))
      .map(function (checkbox) {
        return checkbox.closest(ADDON_SELECTOR);
      })
      .filter(Boolean);
  }

  function getAddonData(addon) {
    return {
      variantId: addon.getAttribute('data-addon-variant-id') || '',
      productHandle: addon.getAttribute('data-addon-product-handle') || '',
      title: addon.getAttribute('data-addon-title') || '',
      shortTitle: addon.getAttribute('data-addon-short-title') || '',
      price: Number(addon.getAttribute('data-addon-price') || 0),
      selectedLabel: addon.getAttribute('data-selected-label') || 'Agregar ambos al carrito'
    };
  }

  function getMessage(addon) {
    return addon.querySelector('[data-td-pdp-addon-message]');
  }

  function setMessage(addon, message, type) {
    var messageEl = getMessage(addon);
    if (!messageEl) return;

    if (!message) {
      messageEl.hidden = true;
      messageEl.textContent = '';
      messageEl.classList.remove('is-error', 'is-success');
      return;
    }

    messageEl.hidden = false;
    messageEl.textContent = message;
    messageEl.classList.toggle('is-error', type === 'error');
    messageEl.classList.toggle('is-success', type === 'success');
  }

  function setMessages(addons, message, type) {
    addons.forEach(function (addon, index) {
      setMessage(addon, index === 0 ? message : '', type);
    });
  }

  function toPositiveInteger(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  }

  function getVariantId(form, formData) {
    var fromFormData = formData.get('id');
    if (fromFormData) return fromFormData;

    var input = form.querySelector('[name="id"]');
    return input ? input.value : '';
  }

  function getLineItemProperties(formData) {
    var properties = {};

    for (var pair of formData.entries()) {
      var key = pair[0];
      var value = pair[1];
      var match = key.match(/^properties\[(.+)\]$/);

      if (match && value !== '') {
        properties[match[1]] = value;
      }
    }

    return Object.keys(properties).length ? properties : undefined;
  }

  function getCartUi() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getSectionsToRender(cart) {
    if (cart && typeof cart.getSectionsToRender === 'function') {
      try {
        return cart.getSectionsToRender().map(function (section) {
          return section.id;
        });
      } catch (error) {
        console.warn('[TD PDP Add-on] No se pudieron leer secciones del carrito:', error);
      }
    }

    return [];
  }

  function setLoading(form, loading) {
    var button = getSubmitButton(form);
    if (!button) return;

    var productForm = form.closest('product-form') || form.parentElement;
    var spinner = productForm ? productForm.querySelector('.loading-overlay__spinner') : null;

    if (loading) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
      return;
    }

    button.classList.remove('loading');
    button.removeAttribute('aria-disabled');
    if (spinner) spinner.classList.add('hidden');
  }

  function hideDynamicCheckout(form, selected) {
    if (!form) return;

    var scope = form.closest('product-info, .product, section') || document;
    var paymentButton =
      form.querySelector('.shopify-payment-button') ||
      scope.querySelector('.shopify-payment-button');

    if (paymentButton) {
      paymentButton.classList.toggle('td-pdp-addon-payment-hidden', selected);
    }
  }

  function setMainButtonLabel(form) {
    var button = getSubmitButton(form);
    var label = getButtonLabel(button);
    if (!button || !label) return;

    if (button.hasAttribute('disabled')) return;

    if (!button.dataset.tdDefaultLabel) {
      button.dataset.tdDefaultLabel =
        (label.textContent || '').trim() ||
        'Agregar al carrito';
    }

    var selectedAddons = getSelectedAddons(form);

    if (!selectedAddons.length) {
      label.textContent = button.dataset.tdDefaultLabel;
      return;
    }

    if (selectedAddons.length === 1) {
      label.textContent =
        selectedAddons[0].getAttribute('data-selected-label') ||
        'Agregar ambos al carrito';
      return;
    }

    label.textContent = 'Agregar producto + ' + selectedAddons.length + ' extras';
  }

  function syncFormState(form) {
    var selectedAddons = getSelectedAddons(form);
    var selected = selectedAddons.length > 0;
    var addonData = selectedAddons.map(getAddonData);
    var addonTotalPrice = addonData.reduce(function (sum, addon) {
      return sum + addon.price;
    }, 0);
    var selectedLabel = selectedAddons.length === 1
      ? addonData[0].selectedLabel
      : selected
        ? 'Agregar producto + ' + selectedAddons.length + ' extras'
        : '';

    form.dataset.tdPdpAddonSelected = selected ? 'true' : 'false';
    form.dataset.tdPdpAddonCount = String(selectedAddons.length);
    form.dataset.tdPdpAddonVariantIds = addonData
      .map(function (addon) { return addon.variantId; })
      .filter(Boolean)
      .join(',');
    form.dataset.tdPdpAddonProductHandles = addonData
      .map(function (addon) { return addon.productHandle; })
      .filter(Boolean)
      .join(',');
    form.dataset.tdPdpAddonTitles = addonData
      .map(function (addon) { return addon.title; })
      .filter(Boolean)
      .join(' | ');
    form.dataset.tdPdpAddonTitle = form.dataset.tdPdpAddonTitles;
    form.dataset.tdPdpAddonShortTitles = addonData
      .map(function (addon) { return addon.shortTitle; })
      .filter(Boolean)
      .join(' + ');
    form.dataset.tdPdpAddonShortTitle = form.dataset.tdPdpAddonShortTitles;
    form.dataset.tdPdpAddonPrice = String(addonTotalPrice);
    form.dataset.tdPdpAddonSelectedLabel = selectedLabel;

    setMainButtonLabel(form);
    hideDynamicCheckout(form, selected);

    document.dispatchEvent(new CustomEvent('td:pdp-addons:change', {
      bubbles: true,
      detail: {
        formId: form.id,
        selected: selected,
        selectedCount: selectedAddons.length,
        addonVariantIds: form.dataset.tdPdpAddonVariantIds,
        addonProductHandles: form.dataset.tdPdpAddonProductHandles,
        addonTitles: form.dataset.tdPdpAddonTitles,
        addonShortTitles: form.dataset.tdPdpAddonShortTitles,
        addonTotalPrice: addonTotalPrice,
        selectedLabel: selectedLabel
      }
    }));
  }

  function dispatchAddonChange(form, addon, selected) {
    var data = getAddonData(addon);

    document.dispatchEvent(new CustomEvent('td:pdp-addon:change', {
      bubbles: true,
      detail: {
        formId: form ? form.id : addon.getAttribute('data-form-id'),
        selected: selected,
        selectedCount: form ? getSelectedAddons(form).length : selected ? 1 : 0,
        price: data.price,
        title: data.title,
        shortTitle: data.shortTitle,
        selectedLabel: data.selectedLabel
      }
    }));
  }

  function syncAddon(addon) {
    var checkbox = addon.querySelector(CHECKBOX_SELECTOR);
    var toggle = addon.querySelector(TOGGLE_SELECTOR);
    var toggleLabel = toggle ? toggle.querySelector('[data-td-pdp-addon-toggle-label]') : null;
    var note = addon.querySelector('[data-td-pdp-addon-selected-note]');
    var form = getForm(addon);

    if (!checkbox || !form) return;

    var selected = checkbox.checked;
    var addLabel = addon.getAttribute('data-toggle-label-add') || 'Sumar a mi compra';
    var removeLabel = addon.getAttribute('data-toggle-label-remove') || 'Quitar';

    addon.classList.toggle('is-selected', selected);
    if (note) note.hidden = !selected;

    if (toggle) {
      toggle.classList.toggle('is-selected', selected);
      toggle.setAttribute('aria-pressed', selected ? 'true' : 'false');
      toggle.setAttribute(
        'aria-label',
        selected ? 'Quitar complemento de la compra' : 'Sumar complemento a mi compra'
      );
    }

    if (toggleLabel) {
      toggleLabel.textContent = selected ? removeLabel : addLabel;
    }

    updateQuickViewSelection(addon, selected);

    setMessage(addon, '');
    syncFormState(form);
    dispatchAddonChange(form, addon, selected);
  }

  function buildPayload(form, addons, sectionIds) {
    var formData = new FormData(form);
    var mainVariantId = toPositiveInteger(getVariantId(form, formData), 0);

    if (!mainVariantId || !Array.isArray(addons) || !addons.length) return null;

    var mainItem = {
      id: mainVariantId,
      quantity: toPositiveInteger(formData.get('quantity'), 1)
    };

    var sellingPlan = formData.get('selling_plan');
    if (sellingPlan) {
      mainItem.selling_plan = Number(sellingPlan);
    }

    var properties = getLineItemProperties(formData);
    if (properties) {
      mainItem.properties = properties;
    }

    var items = [mainItem];

    addons.forEach(function (addon, index) {
      var addonVariantId = toPositiveInteger(addon.getAttribute('data-addon-variant-id'), 0);
      if (!addonVariantId) return;

      items.push({
        id: addonVariantId,
        quantity: 1,
        properties: {
          _td_addon_source: 'pdp_hero',
          _td_addon_index: String(index + 1),
          _td_addon_parent_variant: String(mainVariantId),
          _td_addon_parent_handle: addon.getAttribute('data-main-product-handle') || '',
          _td_addon_product_handle: addon.getAttribute('data-addon-product-handle') || ''
        }
      });
    });

    if (items.length < 2) return null;

    var payload = { items: items };

    if (Array.isArray(sectionIds) && sectionIds.length) {
      payload.sections = sectionIds;
      payload.sections_url = window.location.pathname;
    }

    return payload;
  }

  function renderCart(response, cart) {
    var routes = getRoutes();

    if (!cart) {
      window.location.href = routes.cart_url || '/cart';
      return;
    }

    cart.classList.remove('is-empty');

    var drawerInner = cart.querySelector('.drawer__inner');
    if (drawerInner) drawerInner.classList.remove('is-empty');

    if (typeof cart.renderContents === 'function') {
      cart.renderContents(response);
      return;
    }

    window.location.href = routes.cart_url || '/cart';
  }

  function track(eventName, addon, extra) {
    var payload = Object.assign({
      event: eventName,
      main_product_handle: addon ? addon.getAttribute('data-main-product-handle') || '' : '',
      addon_product_handle: addon ? addon.getAttribute('data-addon-product-handle') || '' : '',
      addon_variant_id: addon ? addon.getAttribute('data-addon-variant-id') || '' : '',
      addon_title: addon ? addon.getAttribute('data-addon-title') || '' : '',
      addon_price: addon ? Number(addon.getAttribute('data-addon-price') || 0) : 0
    }, extra || {});

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(payload);
    }

    document.dispatchEvent(new CustomEvent('td:' + eventName, {
      bubbles: true,
      detail: payload
    }));
  }

  function getQuickView(addon) {
    return addon ? addon.querySelector(QUICKVIEW_SELECTOR) : null;
  }

  function getFocusableElements(container) {
    if (!container) return [];

    return Array.prototype.slice.call(container.querySelectorAll(
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    });
  }

  function updateQuickViewSelection(addon, selected) {
    var selectButton = addon ? addon.querySelector(QUICKVIEW_SELECT_SELECTOR) : null;
    if (!selectButton) return;

    selectButton.textContent = selected ? 'Quitar de mi compra' : 'Sumar a mi compra';
    selectButton.setAttribute('aria-pressed', selected ? 'true' : 'false');
    selectButton.classList.toggle('is-selected', selected);
  }

  function openQuickView(addon, opener) {
    var modal = getQuickView(addon);
    if (!modal) return;

    if (activeQuickView && activeQuickView !== modal) {
      closeQuickView(activeQuickView, false);
    }

    activeQuickView = modal;
    activeQuickViewOpener = opener || document.activeElement;

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.documentElement.classList.add('td-pdp-addon-qv-is-open');

    var dialog = modal.querySelector('[role="dialog"]');
    var closeButton = modal.querySelector(QUICKVIEW_CLOSE_SELECTOR);

    window.requestAnimationFrame(function () {
      (closeButton || dialog || modal).focus({ preventScroll: true });
    });

    track('td_pdp_addon_quickview_opened', addon);
  }

  function closeQuickView(modal, restoreFocus) {
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;

    if (activeQuickView === modal) {
      activeQuickView = null;
    }

    document.documentElement.classList.remove('td-pdp-addon-qv-is-open');

    if (restoreFocus !== false && activeQuickViewOpener && typeof activeQuickViewOpener.focus === 'function') {
      activeQuickViewOpener.focus({ preventScroll: true });
    }

    activeQuickViewOpener = null;
  }

  function selectQuickViewImage(thumb) {
    var modal = thumb.closest(QUICKVIEW_SELECTOR);
    var mainImage = modal ? modal.querySelector('[data-td-pdp-addon-quickview-main-image]') : null;
    if (!mainImage) return;

    var imageSrc = thumb.getAttribute('data-image-src');
    var imageAlt = thumb.getAttribute('data-image-alt') || '';

    if (imageSrc) mainImage.setAttribute('src', imageSrc);
    mainImage.setAttribute('alt', imageAlt);

    modal.querySelectorAll(QUICKVIEW_THUMB_SELECTOR).forEach(function (item) {
      var active = item === thumb;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function toggleAddonFromQuickView(addon) {
    var checkbox = addon.querySelector(CHECKBOX_SELECTOR);
    var modal = getQuickView(addon);
    if (!checkbox) return;

    checkbox.checked = !checkbox.checked;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));

    track(
      checkbox.checked ? 'td_pdp_addon_quickview_selected' : 'td_pdp_addon_quickview_unselected',
      addon,
      { selected_from: 'quickview' }
    );

    closeQuickView(modal, true);
  }

  function initQuickView(addon) {
    var modal = getQuickView(addon);
    if (!modal) return;

    addon.querySelectorAll(QUICKVIEW_OPEN_SELECTOR).forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openQuickView(addon, button);
      });
    });

    addon.querySelectorAll(QUICKVIEW_CLOSE_SELECTOR).forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        closeQuickView(modal, true);
      });
    });

    addon.querySelectorAll(QUICKVIEW_THUMB_SELECTOR).forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        selectQuickViewImage(button);
      });
    });

    addon.querySelectorAll(QUICKVIEW_SELECT_SELECTOR).forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        toggleAddonFromQuickView(addon);
      });
    });
  }

  function onQuickViewKeydown(event) {
    if (!activeQuickView) return;

    if (event.key === 'Escape' || event.code === 'Escape') {
      event.preventDefault();
      closeQuickView(activeQuickView, true);
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = getFocusableElements(activeQuickView);
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
      return;
    }

    if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function submitWithAddons(form, addons) {
    var routes = getRoutes();
    var cart = getCartDrawer() || getCartUi();
    var sections = getSectionsToRender(cart);
    var payload = buildPayload(form, addons, sections);

    if (!payload) {
      setMessages(addons, 'No pudimos agregar el complemento. Inténtalo nuevamente.', 'error');
      return;
    }

    if (cart && typeof cart.setActiveElement === 'function') {
      cart.setActiveElement(document.activeElement);
    }

    setLoading(form, true);
    setMessages(addons, '');

    document.dispatchEvent(new CustomEvent('td:product-form:submit-start', {
      detail: { formId: form.id }
    }));

    fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok) throw json;
          return json;
        });
      })
      .then(function (response) {
        track('td_pdp_addon_added', addons[0], {
          main_quantity: payload.items[0].quantity,
          addon_quantity: payload.items.length - 1,
          addon_product_handles: addons.map(function (addon) {
            return addon.getAttribute('data-addon-product-handle') || '';
          }).join(','),
          addon_variant_ids: addons.map(function (addon) {
            return addon.getAttribute('data-addon-variant-id') || '';
          }).join(',')
        });

        document.dispatchEvent(new CustomEvent('td:product-form:submit-success', {
          detail: {
            formId: form.id,
            response: response,
            addonSelected: true,
            addonCount: addons.length
          }
        }));

        renderCart(response, cart);
      })
      .catch(function (error) {
        console.error('[TD PDP Add-on]', error);

        var message =
          error && (error.description || error.message)
            ? error.description || error.message
            : 'No pudimos agregar los productos. Inténtalo nuevamente.';

        setMessages(addons, message, 'error');

        document.dispatchEvent(new CustomEvent('td:product-form:submit-error', {
          detail: {
            formId: form.id,
            error: error,
            addonSelected: true,
            addonCount: addons.length
          }
        }));
      })
      .finally(function () {
        setLoading(form, false);

        document.dispatchEvent(new CustomEvent('td:product-form:submit-end', {
          detail: {
            formId: form.id,
            hasError: false
          }
        }));
      });
  }

  function onSubmitCapture(event) {
    var form = event.target;

    if (!(form instanceof HTMLFormElement)) return;

    var addons = getSelectedAddons(form);
    if (!addons.length) return;

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    var submitButton = getSubmitButton(form);
    if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;

    submitWithAddons(form, addons);
  }

  function initAddon(addon) {
    if (addon.dataset.tdPdpAddonMounted === 'true') return;

    var checkbox = addon.querySelector(CHECKBOX_SELECTOR);
    var toggle = addon.querySelector(TOGGLE_SELECTOR);
    var form = getForm(addon);

    if (!checkbox || !form) return;

    addon.dataset.tdPdpAddonMounted = 'true';

    if (toggle) {
      toggle.addEventListener('click', function () {
        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    initQuickView(addon);

    checkbox.addEventListener('change', function () {
      syncAddon(addon);

      track(
        checkbox.checked ? 'td_pdp_addon_selected' : 'td_pdp_addon_unselected',
        addon,
        { selected_count: getSelectedAddons(form).length }
      );
    });

    syncAddon(addon);
  }

  function init() {
    document.querySelectorAll(ADDON_SELECTOR).forEach(initAddon);

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (getAddonsForForm(form).length) syncFormState(form);
    });
  }

  document.addEventListener('keydown', onQuickViewKeydown);
  document.addEventListener('submit', onSubmitCapture, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();